
Vue.component('boolean', {
    props: {
        field: {},
        selectedvalue: {},
        offlabel: {
            Type: String,
            default: "N"
        },
        onlabel: {
            Type: String,
            default: "Y"
        },
        booleanvalue: {
            default: "Y"
        },
        selected: {
            type: Boolean,
            default: false
        },
        
    },
    data () {
        return {
            checked: false
        }
    },
    mounted () {
        if (this.selectedvalue == this.onlabel) {
            this.checked = true;
            //this.update (this.onlabel);
            //this.$refs.check.click();
        }
        this.isMounted = true;
        if (this.selected) {
            this.$emit("updateboolean", this.booleanvalue);
        }
        
    },
    methods: {
        update () {
            let val = 'N';                
            if (this.$refs.check.checked) {
                this.checked = true;
                val = this.booleanvalue;
                
            } else {
                this.checked = false
            }
            this.$emit("updateboolean", val);            
            console.log("🚀 ~ file: boolean.js ~ line 51 ~ update ~ val", val)
        }
    }
    
})